import axios from "../axios";
import { GET_PRODUCTS_API } from "../../global/ApiUrl";




// PAYLOAD
//productListAPI Will get products for specific kitcehn it take following payload 
/*{
     "kitchen_names": ["2525postmankitchen","5555postmankitchen"],
      "status": true,
      "serving_day" : "Monday",
      "email": "2222@testpostman.com"
      "device": "ios",
  } */


export const productListAPI = async (payload) => {
    try {
        const response = await axios.post(GET_PRODUCTS_API, payload);
        return response;
    } catch (error) {
        console.log("getProducts axios catch block error", error);
        return error;
    }
};

